import React, { useState, useEffect } from "react";
import {
  deleteMessageStatistic,
  getMessageStatistics,
} from "../../api/MessageStatisticApi";
import { AppRoutes } from "../../AppRoutes";
import { appTitle, dateFormat } from "../common/GeneralConfigurations";
import MessageStatisticListForm from "./MessageStatisticListForm";
import moment from "moment";
import AdnStatus from "../common/adnStatus/AdnStatus";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import { Space } from "antd";
import { DeleteOutlined, SendOutlined } from "@ant-design/icons";
import adnYesNoModal from "../common/adnYesNoModal/AdnYesNoModal";
import { useNavigate } from "react-router-dom";

const ManageMessageStatisticListPage = () => {
  const navigate = useNavigate();
  const title = "Message Statistics";
  const [loading, setLoading] = useState(true);

  const [statistics, setStatistics] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [orderBy, setOrderBy] = useState("");

  useEffect(() => {
    document.title = `${appTitle} - ${title}`;
  }, []);

  useEffect(async () => {
    await fetchData();
  }, [currentPage, orderBy]);

  const fetchData = async () => {
    const res = await getMessageStatistics(currentPage, 10, orderBy);
    if (res.status == 200) {
      res.data.result.forEach((element) => {
        element.createdAt = moment(element.createdAt)?.format(dateFormat);
      });
      setStatistics(res.data.result);
      setTotalRecords(res.data.totalRecords);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    const res = await deleteMessageStatistic(id);
    if (res.status == 204) {
      await fetchData();
    } else {
      AdnMessageError("Failed to delete entry.");
    }
  };

  const columns = [
    {
      title: "Platform",
      dataIndex: "platform",
      key: "platform",
      width: "10%",
    },
    {
      title: "Campaign",
      dataIndex: "campaign",
      key: "campaign",
      width: "20%",
    },
    {
      title: "Body",
      dataIndex: "body",
      key: "body",
      width: "40%",
    },
    {
      title: "Total Sent",
      dataIndex: "totalSent",
      key: "totalSent",
      width: "8%",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "15%",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <SendOutlined
            style={{ color: "black" }}
            onClick={() => {
              navigate(
                AppRoutes.textMessage.createPathWithStatisticId(record.id)
              );
            }}
          />
          <DeleteOutlined
            style={{ color: "red" }}
            onClick={() =>
              adnYesNoModal(async () => await handleDelete(record.id))
            }
          />
        </Space>
      ),
      width: "5%",
    },
  ];

  const historyColumns = [
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      width: "50%",
    },
    {
      title: "Sent",
      dataIndex: "sent",
      key: "sent",
      width: "50%",
      render: (_, record) => (
        <AdnStatus
          deleted={!record.sent}
          activeText=" Sent"
          inactiveText=" Failed to send"
        />
      ),
    },
  ];

  return (
    <MessageStatisticListForm
      title={title}
      loading={loading}
      columns={columns}
      historyColumns={historyColumns}
      statistics={statistics}
      totalRecords={totalRecords}
      currentPage={currentPage}
      handleChangePage={setCurrentPage}
      handleChangeOrder={setOrderBy}
    />
  );
};

export default ManageMessageStatisticListPage;
